import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Form from "react-jsonschema-form-bs4";
import { ApplicationState }  from '../../store';
import * as AuthenticationState from '../../store/authentication';

type Props =
    AuthenticationState.AuthenticationState         // ... state we've requested from the Redux store
    & typeof AuthenticationState.actionCreators     // ... plus action creators we've requested
    & RouteComponentProps<{                         // ... plus incoming routing parameters
        accountId: string;
        token: string;
     }>;

type State = {
}

class RegistrationNew extends React.Component<Props, State> {

    constructor(props:Props){
        super(props);
    }
}

export default withRouter(connect(
    (state: ApplicationState) => state.authentication, // Selects which state properties are merged into the component's props
    AuthenticationState.actionCreators                 // Selects which action creators are merged into the component's props
)(RegistrationNew));
